export default {
    routerName: '文章管理',
    article: {
        title: '标题',
        author: '作者',
        releaseTime: '公开时间',
        createStartTime: '公开开始',
        createEndTime: '公开结束',
        category: '類別',
        hot: '热门',
        recommend: '推荐报道',
        recommendTop: '推荐TOP',
        topic: '話題',
        disabled: '禁用',
        yes: '是',
        no: '否',
        slider: '幻灯片',
        status: '状态',
        statusOption0: '草稿',
        statusOption1: '審査拒绝',
        statusOption2: '審査中',
        statusOption9: '审核通过',
        charge: '有无料',
        charge0: '有料',
        charge1: '无料',
        hits: '浏览量',
        defaultImg: '默认图片',
        body: '詳細',
    },
    table: {
        id: 'ID',
        title: '标题',
        author: '作者',
        status: '状态',
        category: '类别',
        hot: '热',
        recommend: '报',
        recommendTop: '荐T',
        topic: '话',
        slider: '幻',
        disabled: '禁用',
        createBy: '创建者',
        releaseTime: '公开时间',
        charge: '有无料',
        charge0: '有料',
        charge1: '无料',
        hits: '浏览量',
        defaultImg: '默认图片',
    },
    message: {
        delConfirmTitle: '删除警告',
        delIncludeSubNodeConfirm: '所有的子节点也消除吗？',
        delConfirm: '数据确定消除吗？',
    },
};
